import { useUserDisplayInfo } from '@/app/modules/LandingHeaderV2/hooks/useUserDisplayInfo';
import { appClientConfig } from '@/app/utils/appClientConfig';
import { useAnalytics } from '@/app/utils/useAnalytics';
import bannerImage from 'assets/profileBannerDoctor.png';
import cx from 'classnames';
import Image from 'next/image';
import { useState } from 'react';
import { getCookieConsentValue } from 'react-cookie-consent';

import { useMediaQuery } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import styles from './ProfileBanner.module.scss';

export type ProfileBannerProps = {
  cookieConsentOverwrite?: string;
};

export const ProfileBanner = ({ cookieConsentOverwrite }: ProfileBannerProps) => {
  const [closed, setClosed] = useState(false);
  const isDesktop = useMediaQuery('(min-width: 768px)');
  const track = useAnalytics();
  const { isUserLoggedIn } = useUserDisplayInfo();

  const profileUrl = appClientConfig.practitionerProfileUrl ?? '';

  const consent = cookieConsentOverwrite ?? getCookieConsentValue();

  if (consent !== 'true' || isUserLoggedIn) {
    return null;
  }

  const VariablePill = () =>
    isDesktop ? (
      <>
        <span>Top rates,</span> negotiated for you
      </>
    ) : (
      <>Competitive rates</>
    );

  const onBannerClose = () => {
    setClosed(true);
    track('Click', {
      action: 'Close profile banner',
      'element text': '',
      'element type': 'button',
    });
  };

  return (
    <div className={cx(styles.bannerContainer, closed && styles.closed)} role="banner">
      <div className={styles.imageContainer}>
        <Image src={bannerImage} priority={true} alt="" aria-hidden width={200} height={200} />
      </div>

      <div>
        <h3 className={styles.header}>Finding your next job just got easier.</h3>
        <p className={styles.subHeader}>Register to access</p>

        <ul className={styles.benefitsPillsList}>
          <li>
            <span>Exclusive</span> roles
          </li>
          <li>
            <VariablePill />
          </li>
          <li>
            <span>Jobs</span> matched to you
          </li>
        </ul>
      </div>

      <Button
        className={styles.getStartedButton}
        variant="contained"
        href={`${profileUrl}/sign-up`}
        onClick={() =>
          track('Click', {
            action: 'Profile banner - get started',
            'element text': 'Get started',
            'element type': 'button',
          })
        }
      >
        Get started
      </Button>

      <IconButton aria-label="close" className={styles.closeButton} onClick={onBannerClose}>
        <CloseIcon />
      </IconButton>
    </div>
  );
};
